export var CLEAR_DISCOUNT_FORM = 'CLEAR_DISCOUNT_FORM';
export var clearDiscountForm = function clearDiscountForm() {
  return {
    type: SET_DISCOUNT_FORM,
    payload: {}
  };
};
export var SET_DISCOUNT_FORM = 'SET_DISCOUNT_FORM';
export var setDiscountForm = function setDiscountForm(form) {
  return {
    type: SET_DISCOUNT_FORM,
    payload: form
  };
};